import React, { PureComponent } from 'react';
import CommonList from '../../components/CommonLists/list';
import './index.less';
const columns = [
  {
    title: '名称',
    dataIndex: 'title',
    key: 'title',
    render: (text, record) => {
      return (
        <p>
          {record.is_top === 1 && <span className="top">[置顶]</span>}
          {text}
        </p>
      );
    }
  },
  {
    title: '排序',
    dataIndex: 'orders',
    key: 'orders'
  },
  {
    title: '图片',
    dataIndex: 'images',
    key: 'images',
    render: (text, record) => {
      return (
        <p>
          <img src={record.image} width="200" />
        </p>
      );
    }
  }
];

@CommonList(columns, 'pictures')
class PicturesList extends PureComponent {
  constructor() {
    super();
  }
  componentDidMount() {}

  render() {
    return <div />;
  }
}

export default PicturesList;
